import { useQuery } from 'react-query';
import { CustomerInList } from '../../../interfaces/customer.interface';
import { SORT_DIRECTION } from '../../../interfaces/enumerables';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

const getCustomers = async (params: {
  page: number;
  orderBy: string;
  order: string;
  search?: string;
}): Promise<GetEntities<CustomerInList>> => {
  await queryClient?.cancelQueries({ queryKey: ['getCustomers'] });

  const resp = await apiRQ.get<GetEntities<CustomerInList>>('/customers', { params });

  return resp.data;
};

export const useCustomers = (page: number, orderBy = 'id', order = SORT_DIRECTION.ASC, search: string) => {
  return useQuery<GetEntities<CustomerInList>, Error>(
    ['getCustomers', page, orderBy, order, search],
    () => getCustomers({ page, orderBy: orderBy, order, search: search }),
    {
      cacheTime: 500,
      staleTime: 500,
      refetchOnWindowFocus: false,
    },
  );
};
